import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs';
import { ListMetadata } from 'app/models/list-metadata.model';
import { Extlog, ExtlogDetail, ExtlogStatus } from 'app/models/extlog.model';

@Injectable()
export class ExtlogService {

  baseUrl = '/koncentro-customers/extlog';

  constructor(
    private http: HttpClientService,
  ) { }


  /**
    * Tramite metodo GET, restituisce la lista dei log.
    * Prevede obbligatoriamente un offset ed un limite, permettendo la paginazione della lista.
  */
  list(
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<Extlog>, metadata: ListMetadata }> {

    const convertedSearch = (search || []).map((filter: { key: string, value: string }) => {
      if ((filter.key === 'start_date' || filter.key === 'end_date') && filter.value) {
        const parts = filter.value.split('/');
        if (parts.length === 3) {
          return { ...filter, value: `${parts[2]}-${parts[1]}-${parts[0]}` };
        }
      }
      return filter;
    });
    const params = HttpClientService.buildListParams(offset, limit, convertedSearch, globalSearch, sort, sort_dir);
    return this.http.getPaged(this.baseUrl + '/list' +
      (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : ''));
  }

  /**
   * Restituisce il Log dalla Testata
   * @param id
   * @returns
   */
  getLog(id: number) {
    return this.http.get(`${this.baseUrl}/${id}/log`);
  }

  /**
   * Restituisce la lista dei dettagli dalla Testata
   * @param id
   * @returns
   */
  getLogDetails(id: number): Observable<ExtlogDetail[]> {
    return this.http.get(`${this.baseUrl}/${id}/detail`);
  }

  getExtLogStatus(): Observable<ExtlogStatus[]> {
    return this.http.get(`${this.baseUrl}/status`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/extlog/extlog.service.ts